import alertService from '../services/alert.service'
import api, {
  PaginateRequest, PaginateResponse, ResponseCallback
} from '../services/api.service'
import routeUtil from '../utils/route.util'
import { BillOfLadingData } from './billOfLading.api'
import { ContactSiteData } from './contactSite.api'
import { ItemData } from './item.api'
import { PalletData } from './pallet.api'
import { ShipData } from './ship.api'
import { SiteData } from './site.api'
import { UserData } from './user.api'

export interface ShipOrderData {
  id: number
  siteId: number
  customerSiteId: number
  createdBy: number
  updatedBy: number
  deletedBy?: number
  remainingQuantity?: number
  purchaseOrder?: string
  salesOrder?: string
  freightNumber?: string
  note: string
  shipAt: string
  deliveryAt: string
  deletedAt?: string
  createdAt: string
  updatedAt: string
  code: string
  interSite: boolean
  isDeleted: boolean
  billOfLading?: BillOfLadingData
  customerSite?: ContactSiteData
  items?: ItemData[]
  createdUser?: UserData
  updatedUser?: UserData
  ships?: ShipData[]
  site?: SiteData
}

type ShipOrderPaginateResponse = PaginateResponse<ShipOrderData[]>

export interface ShipOrderCreateRequestItem {
  id: number
  quantity: number
}

export type ShipOrderUpdateRequestItem = ShipOrderCreateRequestItem

export interface ShipOrderCreateRequest {
  items?: ShipOrderCreateRequestItem[]
  customerSite?: number
  purchaseOrder?: string
  salesOrder?: string
  freightNumber?: string
  shipDatetime?: string
  deliveryDate?: string
  note?: string
}

export interface ShipOrderUpdateRequest {
  items?: ShipOrderUpdateRequestItem[]
  itemsDeleted?: number[]
  purchaseOrder?: string
  salesOrder?: string
  freightNumber?: string
  shipDatetime?: string
  deliveryDate?: string
  note?: string
}

const routes = {
  searchByCode: '/shipOrders/search/code',
  listItems: '/shipOrders/{id}/items',
  paginate: '/shipOrders/paginate',
  delete: '/shipOrders/{id}',
  create: '/shipOrders',
  read: '/shipOrders/{id}',
  update: '/shipOrders/{id}',
  listPallets: '/shipOrders/{id}/pallets',
  exportPallets: '/shipOrders/{id}/pallets/export',
  printPallets: '/shipOrders/{id}/pallets/print'
}

export default {
  searchByCode (code: string, callback: ResponseCallback<ShipOrderData[]>) {
    const params = { code }
    api.get(routes.searchByCode, params, callback)
  },

  listItems (id: number, callback: ResponseCallback<ItemData[]>) {
    const url = routeUtil.replaceParams(routes.listItems, { id })
    api.get(url, {}, callback)
  },

  paginate (
    params: PaginateRequest,
    callback: ResponseCallback<ShipOrderPaginateResponse>
  ) {
    api.get(routes.paginate, params, callback)
  },

  delete (id: number, callback: ResponseCallback<ShipOrderData>) {
    const url = routeUtil.replaceParams(routes.delete, { id })
    api.delete(url, {}, callback)
  },

  create (
    payload: ShipOrderCreateRequest,
    callback: ResponseCallback<ShipOrderData>
  ) {
    api.post(routes.create, payload, callback)
  },

  read (id: number, callback: ResponseCallback<ShipOrderData>) {
    const url = routeUtil.replaceParams(routes.read, { id })
    api.get(url, {}, callback)
  },

  update (
    id: number,
    payload: ShipOrderUpdateRequest,
    callback: ResponseCallback<ShipOrderData>
  ) {
    const url = routeUtil.replaceParams(routes.update, { id })
    api.patch(url, payload, callback)
  },

  listPallets (id: number, callback: ResponseCallback<PalletData[]>) {
    const url = routeUtil.replaceParams(routes.listPallets, { id })
    api.get(url, {}, callback)
  },

  exportPallets (id: number, callback: ResponseCallback<Blob>) {
    const url = routeUtil.replaceParams(routes.exportPallets, { id })
    api.get(url, {}, callback)
  },

  printPallets (id: number, callback: ResponseCallback<string>) {
    alertService.info('Ship order pallets generating...')
    const url = routeUtil.replaceParams(routes.printPallets, { id })
    api.get(url, {}, callback)
  }
}
